module.exports = __webpack_public_path__ + "static/media/Battery-25.e46c0dce.svg";